"use strict";

export { default } from './BottomSheetDraggableView';
//# sourceMappingURL=index.js.map